export default __webpack_public_path__ + "static/media/kitchen4-afterF.c52cdc70.jpg";